export const viewTitle = "Реестр МЧД";
export const viewUniqKey = "mrp";
